import { configureStore } from '@reduxjs/toolkit'
import { cartMiddleware } from './middleware/cartMiddleware'
import cartReducer from './slices/cartSlice'
import categoriesReducer from './slices/categoriesSlice'
import likedReducer from './slices/likedSlice'
import productsReducer from './slices/productsSlice'
import uiReducer from './slices/uiSlice'
import userReducer from './slices/userSlice'
import wishlistModalReducer from './slices/wishlistModalSlice'
import wishlistReducer from './slices/wishlistSlice'

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    products: productsReducer,
    categories: categoriesReducer,
    liked: likedReducer,
    ui: uiReducer,
    user: userReducer,
    wishlist: wishlistReducer,
    wishlistModal: wishlistModalReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(cartMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
